<template lang="pug" src="./custom-services-sections.pug"></template>

<script>
import { showModal, showAccordion } from 'components/mixins'

export default {
  props: ['props'],
  mixins: [showModal, showAccordion]
}
</script>



// WEBPACK FOOTER //
// custom-services-sections.vue?2a8fb124